// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LzFC","name":"styles_name__1xj6E","phone":"styles_phone__Gtz0D"};